import { WhitelistProvider } from "../../context";
import ContentWhitelistPage from "./content";

const WhitelistPage = () => {
  return (
    <WhitelistProvider>
      <ContentWhitelistPage />
    </WhitelistProvider>
  );
};

export default WhitelistPage;
